import { NgModule } from '@angular/core';
import { NcWeatherService } from './weather.service';

@NgModule({
    providers: [NcWeatherService]
})
export class NcWeatherServiceModule { }